<template>
    <div class="add-more-action-buttons">
        <div class="add-more-decrement"
                @click="decrement(theKey)">-</div>
        <div class="add-more-increment"
                @click="increment(theKey)">+</div>
    </div>
</template>


<script>
import { mapActions, mapState } from "vuex";
export default {
  props: ["name", "plural", "theKey", "equipment"],
  data() {
    return {
      initialQuantity: null,
      initialized: false
    };
  },
  computed: {
    ...mapState(["lead", "automationInterestsMore"])
  },
  methods: {
    ...mapActions(["removeAutomationInterest", "setInterestedEquipmentQty"]),

    cancelAddMore(key) {
      // Reset the quantity back to 1
      this.setInterestedEquipmentQty({
        key: key,
        qty: this.initialQuantity || 0
      });

      // Hide the addMore
      this.closeAddMore(key);
    },

    closeAddMore(key) {
      this.$store.state.automationInterestsMore[key] = false;
    },

    decrement(key) {
      this.initializeQty();
      let quantity = this.lead.automationQuantities[key];
      if (quantity > 0) {
        quantity--;
        this.setInterestedEquipmentQty({
          key: key,
          qty: quantity
        });
      }
    },

    increment(key) {
      this.initializeQty();
      let quantity = this.lead.automationQuantities[key];
      quantity++;
      this.setInterestedEquipmentQty({
        key: key,
        qty: quantity
      });
    },

    initializeQty() {
      if (!this.initialized) {
        this.initialQuantity = this.$store.state.lead.automationQuantities[
          this.theKey
        ];
        this.initialized = true;
      }
    }
  },

  updated() {
    this.initializeQty();
  }
};
</script>

<style lang="css">
</style>
